const printByBluetooth = async (content) => {
    const device = await requestBluetoothPrinter();
    if (!device) return false;

    const { service } = await connectToPrinter(device);
    if (!service) return false;

    const result = await sendPrintCommand(service, content);

    await disconnectPrinter(device);

    return result;
};

const requestBluetoothPrinter = async () => {
    try {
        if (!navigator.bluetooth) {
            console.error('Web Bluetooth API no está disponible en este navegador.');
            return;
        }

        const device = await navigator.bluetooth.requestDevice({
            // filters: [{
            //     name: 'Printer-80' 
            // }],
            filters: [{ classCode: 7 }], // Printers
            optionalServices: ['battery_service', 'generic_access']
        });

        return device;
    } catch (error) {
        console.error('Error al solicitar dispositivo Bluetooth:', error);
        return null;
    }
};

const connectToPrinter = async (device) => {
    try {
        const server = await device.gatt.connect();

        const service = await server.getPrimaryService('printer_service_uuid'); // TODO ADV: Change UUID

        return { server, service };
    } catch (error) {
        console.error('Error al conectar al dispositivo o obtener servicio:', error);
        return null;
    }
};

const sendPrintCommand = async (service, content) => {
    try {
        const characteristic = await service.getCharacteristic('characteristic_uuid');

        const encoder = new TextEncoder();
        const printData = encoder.encode(content);

        await characteristic.writeValue(printData);
        return true;

    } catch (error) {
        console.error('Error al enviar el comando de impresión:', error);
        return false;
    }
};

const disconnectPrinter = async (device) => {
    if (device.gatt.connected) {
        device.gatt.disconnect();
    }
};

export { printByBluetooth }